import { render, staticRenderFns } from "./AIDetails.vue?vue&type=template&id=28f4300e&scoped=true&"
import script from "./AIDetails.vue?vue&type=script&lang=js&"
export * from "./AIDetails.vue?vue&type=script&lang=js&"
import style0 from "./AIDetails.vue?vue&type=style&index=0&id=28f4300e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4300e",
  null
  
)

export default component.exports